var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account-outline_svg__clip0_230_2256)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10a5 5 0 0110 0v2a5 5 0 01-10 0v-2zm5-3a3 3 0 00-3 3v2a3 3 0 006 0v-2a3 3 0 00-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.64 21.997A11.944 11.944 0 0112 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12a11.988 11.988 0 01-5.36 9.997zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.982 9.982 0 01-3.787 7.836A7.048 7.048 0 0013.5 18h-3a6.98 6.98 0 00-4.72 1.83A9.982 9.982 0 012 12zm5.554 8.96A9.959 9.959 0 0012 22a9.959 9.959 0 004.435-1.035A5.016 5.016 0 0013.5 20h-3c-1.101 0-2.12.356-2.946.96z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account-outline_svg__clip0_230_2256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgAccountOutline;